<div class="margin" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="row wrap" fxLayoutGap="16px grid">
    @for (sector of sectorList; track sector) {
      <div fxLayout="column" fxFlex="33.33" class="card">
        <div class="border">
          <div class="card-margin">
            <div fxLayout="column" fxLayoutGap="12px">
              <span class="title">{{sector.nome}}</span>
              <span class="description truncate" matTooltip="{{sector.descricao}}" [matTooltipClass]="'tooltip-font'">
                {{sector.descricao}}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>

@if (sectorList.length === 0 && !isLoading) {
  <div fxLayout="row" fxLayoutAlign="center center">
    Não há setores cadastrados
  </div>
}